import { render, staticRenderFns } from "./BaseGrid.vue?vue&type=template&id=48e3bf72&scoped=true&lang=pug&"
import script from "./BaseGrid.vue?vue&type=script&lang=ts&"
export * from "./BaseGrid.vue?vue&type=script&lang=ts&"
import style0 from "./BaseGrid.vue?vue&type=style&index=0&id=48e3bf72&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e3bf72",
  null
  
)

export default component.exports